<ng-container *ngIf="hasError">{{ errorMessages | joinArray }}</ng-container>